module.exports = __webpack_public_path__ + "img/20200319110126656.d161f86f.png";